import { addNewMiddleWare } from 'owa-middleware';
import { addDatapointMiddleware } from 'owa-analytics';
import { hasQueryStringParameter } from 'owa-querystring';
import { traceMiddleware } from 'owa-trace/lib/middleware';

export default function initializeSatchelMiddleware(): void {
    // Add the framework middleware to any middleware the app might want bootstrapped
    const middleware = [addDatapointMiddleware];

    if (
        process.env.NODE_ENV !== 'production' &&
        /**
         * Get URL params and check that "enableTracing" is non-null (i.e. it's
         * present) before enabling tracing.
         */ hasQueryStringParameter('enableTracing')
    ) {
        // turn on tracing
        middleware.push(traceMiddleware);
    }

    addNewMiddleWare(middleware);
}
